import api, {ApiResponse} from '../api';
import {
    AUTH_ENDPOINT,
    OAUTH_ENDPOINT,
    COMPANIES_ENDPOINT,
    SFTP_ENDPOINT
} from './constants';
import {
    CheckStatusParams,
    CheckStatusResponseData,
    SignUpParams,
    SignUpResponseData,
    GetCompanyResponseData,
    ValidateSFTPSecretParams,
    ValidateSFTPSecretResponseData,
    GenerateSFTPPasswordParams,
    GenerateSFTPPasswordResponseData
} from './types';

class ApiServices {
    refreshToken = async ({refreshData, refreshConfig}) => {
        return api.post(`${OAUTH_ENDPOINT}/token`, refreshData, refreshConfig);
    };

    checkStatus = async ({login}: CheckStatusParams): Promise<ApiResponse<CheckStatusResponseData>> => {
        return api.get(`${AUTH_ENDPOINT}/get_user_status/${login}`);
    };

    signUp = async ({login}: SignUpParams): Promise<ApiResponse<SignUpResponseData>> => {
        return api.post(`${AUTH_ENDPOINT}/send_activation_link`, {login});
    };

    getCompany = async (companyName: string): Promise<ApiResponse<GetCompanyResponseData>> => {
        return api.get(COMPANIES_ENDPOINT, {query: companyName});
    };

    validateSFTPSecret = async ({secret}: ValidateSFTPSecretParams): Promise<ApiResponse<ValidateSFTPSecretResponseData>> => {
        return api.post(`${SFTP_ENDPOINT}/validate_secret`, {secret});
    };

    generateSFTPPassword = async ({secret}: GenerateSFTPPasswordParams): Promise<ApiResponse<GenerateSFTPPasswordResponseData>> => {
        return api.post(`${SFTP_ENDPOINT}/generate_and_set_password`, {secret});
    };
}

export default new ApiServices();
